import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import SignUp from "@/pages/SignUp";
import Programs from "@/pages/Programs";
import CalendarPage from "@/pages/CalendarPage";
import ParentDashboard from "@/pages/ParentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import TeacherDashboard from "@/pages/TeacherDashboard";
import Checkout from "@/pages/Checkout";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ProfileSettings from "@/pages/ProfileSettings";
import SuperAdminConsole from "@/pages/SuperAdminConsole";
import ForcePasswordChange from "@/components/ForcePasswordChange";

function Protected({ roles, children }) {
    const { user } = useAuth();
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
    return children;
}

function Shell({ children }) {
    return (
        <div className="App">
            <Navbar />
            {children}
            <Footer />
            <ForcePasswordChange />
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <I18nProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/" element={<Shell><Landing /></Shell>} />
                        <Route path="/programs" element={<Shell><Programs /></Shell>} />
                        <Route path="/calendar" element={<Shell><CalendarPage /></Shell>} />
                        <Route path="/login" element={<Shell><Login /></Shell>} />
                        <Route path="/signup" element={<Shell><SignUp /></Shell>} />
                        <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
                        <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
                        <Route path="/profile" element={<Shell><Protected><ProfileSettings /></Protected></Shell>} />
                        <Route path="/superadmin" element={<Shell><Protected roles={["superadmin"]}><SuperAdminConsole /></Protected></Shell>} />
                        <Route path="/dashboard" element={<Shell><Protected roles={["parent", "teacher", "admin", "superadmin"]}><ParentDashboard /></Protected></Shell>} />
                        <Route path="/checkout/:regId" element={<Shell><Protected roles={["parent", "teacher", "admin", "superadmin"]}><Checkout /></Protected></Shell>} />
                        <Route path="/admin/*" element={<Shell><Protected roles={["admin", "superadmin"]}><AdminDashboard /></Protected></Shell>} />
                        <Route path="/teacher" element={<Shell><Protected roles={["teacher", "admin", "superadmin"]}><TeacherDashboard /></Protected></Shell>} />
                    </Routes>
                </BrowserRouter>
            </I18nProvider>
        </AuthProvider>
    );
}

export default App;
